import { apiClient } from './apiClient';
import type { PortalAutoOpenPreferenceResponse } from '../types/portalAutoOpen';

/**
 * The user's opt-out for AcombaGO auto-opening the ComptaAI panel at sign-in. AcombaGO reads the
 * decision itself before the panel exists, so nothing here has to notify the host.
 */
export const portalAutoOpenService = {
    get: (): Promise<PortalAutoOpenPreferenceResponse> =>
        apiClient.get<PortalAutoOpenPreferenceResponse>('/users/portal-auto-open'),

    set: (enabled: boolean): Promise<void> =>
        apiClient.put<void>('/users/portal-auto-open', { enabled }),
};
